export default {
  install(Vue) {
    if (this.installed) {
      return;
    }
    this.installed = true;
    this.dispatcher = new Vue();

    Vue.prototype.$broadcast = () => this.dispatcher;
  },
};
